import React, { Component } from 'react';

import { withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';

import Button from '../../artzu-ui/src/Button';

const GQL_ROOT = `${process.env.REACT_APP_API_URL}/graphql`;

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clicked: false,
    };
  }

  createUser = () => {};

  newUser = () => {
    const { params, updateErrors, tryLogin, history } = this.props;

    const queryString = `
    mutation CreateUser($params: UserAttributes!, $verifyDevice: Boolean!) {
      createUser(params: $params, verifyDevice: $verifyDevice) {
        errors {
          path
          message
        }
      }
    }
  `;

    this.setState({ clicked: true });

    fetch(GQL_ROOT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: queryString,
        variables: { params, verifyDevice: true },
      }),
    })
      .then(res => res.json())
      .then(json => json.data)
      .then(data => {
        this.setState({ clicked: false });
        if (!data.createUser.errors) {
          tryLogin({ email: params.email, password: params.password }, history);
        } else {
          updateErrors(data.createUser.errors);
        }
      })
      .catch(error => {
        this.setState({ clicked: false });
      });
  };

  render() {
    return (
      <div className="signup__footer">
        <div className="signup__footer--container container">
          <Button
            className="signup__footer--button"
            primary
            label="Sign Up"
            onClick={() => {
              if (this.props.validate() && !this.state.clicked) {
                this.newUser();
              }
            }}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(withApollo(Footer));



// WEBPACK FOOTER //
// ./src/components/SignUp/Footer.js